import { useTimezone } from '@app/core/hooks/useTimezone';
import { ThumbnailsStream } from '@mi-front/ui';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_UI_CONFIG } from '../../consts';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { useLoggerRangeThumbnails } from './hooks/useLoggerRangeThumbnails';

export const LoggerVideoPreview = () => {
  const { thumbnails, isLoading } = useLoggerRangeThumbnails();
  const range = useStreamSegmentsRange();

  return (
    <PreviewWrapper
      data-testid="logger-video-preview"
      data-range-from={range.from}
      data-range-to={range.to}
    >
      <ThumbnailsStream
        compressed
        tz={useTimezone()}
        height={STREAM_UI_CONFIG.previewHeight}
        range={range}
        disableHtmlEvents
        renderSvg={() => <PreviewBrush />}
        renderHtml={() => <PreviewFocusMarkers />}
        thumbnails={thumbnails}
        thumbnailsLoading={isLoading}
      />
    </PreviewWrapper>
  );
};
